import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import router from './router';
import alert from '../src/components/Alert.vue';
import i18n from './i18n';
import VueCookies from 'vue-cookies';
import store from './stores/AppStore';

import mixin from './plugins/mixin';

import VueGtag from 'vue-gtag';

Vue.use(VueGtag, {}, router);

Vue.use(VueCookies);

Vue.prototype.$eventHub = new Vue(); // Global event bus

const isProduction = process.env.NODE_ENV === 'production';

Vue.prototype.$intercomMessage = isProduction;

Vue.component('alert', alert);

Vue.config.productionTip = false;

Vue.mixin(mixin);

new Vue({
  i18n,
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
